import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type { ICreateCampaign } from '@app/dashboard/types/innerLayout/reach/modals/create-modal';

export const fetchSenderName = async () => {
  return axiosPrivate.get('/reach/get_merchant_sender_name/');
};

export const fetchCampaigns = async (data: {
  params?: Record<string, any>;
  currentPage?: number;
  pageSize?: number;
}) => {
  const { params, currentPage, pageSize } = data;

  const payload = {
    ...params,
    page: currentPage,
    page_size: pageSize,
  };

  return axiosPrivate.get(`/reach/bulk_upload_campaign_list/`, {
    params: payload,
  });
};

export const createCampaign = (payload: ICreateCampaign) => {
  return axiosPrivate.post(`/reach/bulk_upload_campaign/`, payload);
};
